import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '../../contexts';

const useStyles = () => {
    const theme = useWolfTheme();
    return useMemo(
        () => ({
            withLabel: css({
                display: 'flex',
                gap: theme.orbitalFour,
                alignItems: 'center',

                a: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: theme.orbitalTwo,
                },
            }),
        }),
        [theme.orbitalFour, theme.orbitalTwo]
    );
};

export default useStyles;
